(function () {
  var list = document.getElementById('kaw-sitemap-products');
  if (!list) return;

  list.style.visibility = 'hidden';

  var limit = 250;
  var page = 1;
  var allProducts = [];

  function fetchPage(pg) {
    return fetch('/products.json?limit=' + limit + '&page=' + pg)
      .then(function (res) { return res.json(); })
      .then(function (data) { return data.products; });
  }

  function loadAll() {
    fetchPage(page).then(function handlePage(products) {
      allProducts = allProducts.concat(products);
      if (products.length >= limit) {
        page++;
        return fetchPage(page).then(handlePage);
      }

      allProducts.sort(function (a, b) {
        return a.title.localeCompare(b.title);
      });

      var fragment = document.createDocumentFragment();
      for (var i = 0; i < allProducts.length; i++) {
        var li = document.createElement('li');
        li.className = 'kaw-sitemap__product-item';
        var a = document.createElement('a');
        a.href = '/products/' + allProducts[i].handle;
        a.textContent = allProducts[i].title;
        li.appendChild(a);
        fragment.appendChild(li);
      }

      list.appendChild(fragment);
      list.style.visibility = 'visible';
    });
  }

  loadAll();
})();
